import { SimpleGrid, Stack } from '@mantine/core'
import { first, map, values } from 'lodash'
import React, { ReactElement, useEffect, useMemo } from 'react'

import { getMapTiles } from '../../mapTiles'
import { Item } from './Item'

type TMapStyleSelectProps = {
  value?: string
  onChange?: (value: string) => void
}

export const MapStyleSelect = (props: TMapStyleSelectProps): ReactElement => {
  const { onChange, value } = props

  const maptiles = useMemo(() => getMapTiles({ lowres: true }), [])

  const onSelect = (name: string): void => {
    if (onChange) {
      onChange(name)
    }
  }

  return (
    <>
      <SimpleGrid spacing="xs" cols={2}>
        {map(maptiles, (maptile) => (
          <Item
            key={maptile.name}
            maptile={maptile}
            onSelect={onSelect}
            isSelected={maptile.name === value}
          />
        ))}
      </SimpleGrid>
    </>
  )
}
